<template>
  <div class="page">
    <p class="p1">
      个人中心
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="information">
      <div class="tx_class">
        <img src="../../assets/img/tx_portrait.png" alt="">
      </div>
      <div class="phone_class">
        <span style="font-size: 13px;">{{userData.phone}}</span>
      </div>
      <div class="loginOut" @click="loginOut">退出</div>
    </div>
    <div class="user-class">
      <div class="user-div" @click="rechargeBalance()">
        <p class="num-class">{{userData.userAsset}}</p>
        <p>余额</p>
      </div>
      <div class="user-div" @click="integral()">
        <p class="num-class">{{userData.userIntegral}}</p>
        <p>积分</p>
      </div>
      <div class="user-div" @click="rechargeBalance()">
        <p class="num-class">0</p>
        <p>签到</p>
      </div>
    </div>
    <div class="buttons-class">
      <span @click="addCard()">添加卡</span>
      <span @click="batchRecharge()">批量充值</span>
      <span @click="orderList()">我的订单</span>
      <span @click="invoiceList()">我的记录</span>
    </div>
    <div class="detail-box">
      <nut-tab line-width="20" @tab-switch="tabSwitch" :init-data="lists">
        <nut-tab-panel v-for="(item,index) in lists" :key="index" :tab-title="item">
          <ul class="data-class">
            <li class="tab-li" v-for="(item,index) in dataList" :key="index">
              <div style="width:10%">
                <nut-checkbox v-model="item.xz" @change="singleChoice()" size="small"></nut-checkbox>
              </div>
              <div  style="width:90%">
                <p>
                  <span @click="jumpTo(item.iccid)" style="color: #F94040;">{{item.iccid}}</span>
                  <span>状态：{{item.showStatus}}</span>
                </p>
                <p>
                  <span>有效期至：{{item.expireTime}}</span>
                  <nut-button small @click="unbound(item.iccid)">解绑</nut-button>
                </p>
              </div>
            </li>
          </ul>
        </nut-tab-panel>
      </nut-tab>
    </div>
    <!-- 弹窗部分 -->
    <nut-popup :style="{ padding: '30px 50px' }" v-model="showAddCard" closeable>
      <nut-textinput placeholder="请输入ICCID" v-model="newIccid"/>
      <span style="margin: 3px 0;display: inline-block;">温馨提示：请添加本人名下有效卡片</span>
      <div class="addButton">
        <nut-button @click="bindingCard()" class="newCard-class">提交</nut-button>
      </div>
    </nut-popup>
  </div>
</template>
<script>
import { wx_userInfo } from "@/api/api.js"; // 初始化获取数据
import { wx_bindCard } from "@/api/api.js"; // 添加新卡
import { wx_bindCardInfo } from "@/api/api.js"; // 获取添加卡后的数据
import { wx_unBindCard } from "@/api/api.js"; // 解绑卡
export default {
  data() {
    return {
      userData:{
        phone:"",
        userAsset:"0",
        userIntegral:"0"
      },
      showAddCard:false,
      newIccid:"",
      lists:[],
      dataList:[],
      selectList:[]
    }
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      if(localStorage.getItem("mobileToken")){
        history.go(-2);
      }else{
        this.$router.go(-1);
      }
    },
    // 获取初始化数据
    initData(){
      wx_userInfo().then(res=>{
        if(res.data.code == 200){
          this.userData.phone = res.data.data.phone;
          this.userData.userAsset = res.data.data.userAsset;
          this.userData.userIntegral = res.data.data.userIntegral;
          this.lists = res.data.data.cardInfo;
          this.obtainBindingCard(1);
        }else if(res.data.code == 401){
          localStorage.removeItem("mobileToken");
          this.$router.push({
            name: "userLogin",
          });
        }
      });
    },
    // 退出登陆
    loginOut(){
      localStorage.removeItem("mobileToken");
      localStorage.removeItem("addCardIccid");
      this.$router.push({
        name: "userLogin",
      });
    },
    // 跳转卡详情
    jumpTo(val){
      window.location.href = `/dist/?code=${localStorage.getItem('code')}&state=1#/info?iccid=${val}`
    },
    // 充值余额
    rechargeBalance(){
      return this.$toast.fail('开发中');
      this.$router.push({
        name: "userBalance",
      });
    },
    // 使用积分
    integral(){
      this.$router.push({
        name: "userIntegral",
      });
    },
    // tab切换
    tabSwitch(index){
      this.obtainBindingCard(index + 1);
    },
    // 选中的数据
    singleChoice(){
      let newArr = this.dataList.filter(item => {
        return item.xz == true
      })
      this.selectList = newArr.map(item=>{
        return item.iccid
      })
    },
    // 添加新卡弹窗
    addCard(){
      this.showAddCard = true;
      this.newIccid = localStorage.getItem("addCardIccid")
    },
    // 添加新卡确认
    bindingCard(){
      let params = {
        iccid:this.newIccid
      }
      wx_bindCard(params).then(res =>{
        if(res.data.code == 200){
          this.$toast.success('绑卡成功');
          this.showAddCard = false;
          this.initData();
          this.newIccid = "";
        }else{
          this.$toast.fail(res.data.message);
          this.newIccid = "";
          this.showAddCard = false;
        }
      })
    },
    // 获取添加卡后的数据
    obtainBindingCard(val){
      let params = {
        operationId : val
      }
      wx_bindCardInfo(params).then(res=>{
        if(res.data.code == 200){
          this.dataList = res.data.data
        }
      })
    },
    // 批量充值
    batchRecharge(){
      if(this.selectList.length){
        this.$store.commit("iccidsMethod",this.selectList);
        this.$router.push({
          name: "userMeal",
        });
      }else{
        this.$toast.fail('至少选择一张卡');
      }
    },
    // 卡解绑
    unbound(val){
      let that = this;
      this.$dialog({
        title: "确定要解绑此卡吗？",
        onOkBtn(event) { 
          let params ={
            iccid:val
          }
          wx_unBindCard(params).then(res =>{
            if(res.data.code == 200){
              this.close(); //关闭对话框
              that.initData();
            }else{
              this.$toast.fail('操作失败！');
              this.close();
            }
          })
        },
      });
    },
    // 我的订单
    orderList(){
      this.$router.push({
        name: "userOrderList",
      });
    },
    // 我的发票记录
    invoiceList(){
      this.$router.push({
        name: "userInvoiceList",
      });
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    window.document.title = "个人中心";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }

    .information{
      height: 50px;
      line-height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 3px;
      .tx_class{
        width: 50px;
        height: 50px;
        img{
          border-radius: 50%;
        }
      }
      .loginOut{
        width: 45px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        background: #F94040;
        border-radius: 5px;
        color: #fff;
        font-size: 13px;
      }
    }
    .user-class{
      margin: 12px 0;
      height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .user-div{
        height: 50px;
        p{
          text-align: center;
          height: 25px;
          line-height: 25px;
        }
        .num-class{
          font-size: 13px;
          font-weight: bold;
        }
      }
    }
    .buttons-class{
      display: flex;
      justify-content: space-around;
      margin: 20px 0;
      span{
        display: inline-block;
        width: 60px;
        height: 25px;
        line-height: 25px;
        background: #F94040;
        text-align: center;
        color: #fff;
        border-radius: 5px;
      }
    }
    .detail-box{
      margin-top: 10px;
      width: 100%;
      position: relative;
      /deep/ .nut-tab-link {
        font-size: 14px;
      }
      /deep/ .nut-tab-title {
        height: 40px;
        line-height: 40px;
      }
    }
    /deep/ .nut-tab{
      padding: 0;
      border: none;
    }
    /deep/ .nut-tab-item{
      // height: auto;
      height: 200px;
      padding: 0;
    }
    /deep/ .nav-bar{
      background: #F94040!important;
    }
    /deep/ .nut-tab-active{
      .nut-tab-link{
        color:#F94040 !important;
      }
    }
    .data-class{
      // width: 90%;
      // margin: 0 auto;
      .tab-li{
        display: flex;
        align-items: center;
        width: 100%;
        padding: 5px 13px;
        background: #fff;
        width: 100%;
        height: 60px;
        font-size: 13px;
        border-bottom: 2px solid #ededed;
        p{
          display: flex;
          justify-content: space-between;
          margin: 5px 0;
          /deep/ .nut-button.small{
            height: 25px;
            padding: 0 10px;
            font-size: 12px;
            border-radius:5px;
            background:#F94040;
          }
        }
      }
    }
    .addButton{
      text-align: center;
      // margin-top: 15px;
      /deep/ .nut-button{
        background:#F94040;
        border-radius:5px;
      }
    }
  }
</style>

